import { makeVar } from '@apollo/client';

export const reactiveFeedbackMessage = makeVar({
  message: '',
  isError: true,
  autoclose: true,
});
